<div class="prompt-detail-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <div class="header-content">
      <h2 mat-dialog-title>{{ promptDetail?.prompt_text || 'Prompt Details' }}</h2>
    </div>
    <div class="header-controls">
      <!-- <mat-form-field appearance="outline" class="location-field">
        <mat-label>Location</mat-label>
        <mat-select [(ngModel)]="location">
          @for (country of countryOptions; track country) {
            <mat-option [value]="country">{{ country }}</mat-option>
          }
        </mat-select>
      </mat-form-field> -->
      <mat-form-field appearance="outline" class="date-field">
        <mat-label>Date</mat-label>
        <input matInput [value]="selectedDate" readonly>
      </mat-form-field>
      <!-- <div class="custom-date-toggle">
        <mat-checkbox [(ngModel)]="useCustomDateRange" (change)="onDateFilterChange()">Custom Date Range</mat-checkbox>
      </div> -->
    </div>
    <button mat-icon-button (click)="onClose()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- Loading State -->
    @if (loading) {
      <div class="loading-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>Loading prompt details...</p>
      </div>
    }

    <!-- Error State -->
    @if (error && !loading) {
      <div class="error-container">
        <mat-icon class="error-icon">error_outline</mat-icon>
        <p class="error-message">{{ error }}</p>
        <button mat-button color="primary" (click)="loadPromptDetail()">Retry</button>
      </div>
    }

    <!-- Prompt Detail Content -->
    @if (promptDetail && !loading) {
      <div class="prompt-detail-content">
        <!-- Section 1: AI-Generated Content -->
        <div class="content-section">
          <div class="section-header">
            <h3>AI-Generated Content:</h3>
            <div class="section-actions">
              <span class="snapshot-info">Data collected on {{ formatTimestamp(promptDetail.snapshot_timestamp) }}</span>
            </div>
          </div>
          <div class="ai-content">
            @if (promptDetail.ai_overview) {
              <p class="ai-overview">{{ promptDetail.ai_overview }}</p>
            }
            <div class="ai-full-content" [innerHTML]="formatAIContent(promptDetail.ai_content)"></div>
          </div>
        </div>

        <!-- Section 2: Mentions -->
        @if (promptDetail.mentions.length > 0) {
          <div class="content-section">
            <div class="section-header">
              <h3>Mentions</h3>
              <span class="count-badge">{{ promptDetail.mentions_count }}</span>
            </div>
            <div class="mentions-container">
              @for (brand of promptDetail.mentions; track brand) {
                <span class="brand-pill">{{ brand }}</span>
              }
            </div>
          </div>
        }

        <!-- Section 3: Citations -->
        @if (promptDetail.citations.length > 0) {
          <div class="content-section">
            <div class="section-header">
              <h3>Sources & Citations</h3>
              <span class="count-badge">{{ promptDetail.citations_count }}</span>
            </div>
            <app-citation-card
              [citations]="formatCitations(promptDetail.citations)"
              [title]="'Sources & Citations'"
              [displayStyle]="'grid'"
              [maxDisplay]="6">
            </app-citation-card>
          </div>
        }

        <!-- Metrics Summary -->
        <div class="metrics-summary">
          <div class="metric-item">
            <span class="metric-label">Volume:</span>
            <span class="metric-value">{{ promptDetail.volume ? promptDetail.volume.toLocaleString() : '-' }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Mentions:</span>
            <span class="metric-value">{{ promptDetail.mentions_count }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Citations:</span>
            <span class="metric-value">{{ promptDetail.citations_count }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">Impressions:</span>
            <span class="metric-value">{{ promptDetail.impressions.toLocaleString() }}</span>
          </div>
          <div class="metric-item">
            <span class="metric-label">AI Share of Voice:</span>
            <span class="metric-value">{{ promptDetail.ai_share_of_voice }}%</span>
          </div>
        </div>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div>
